module.exports = __webpack_public_path__ + "static/media/school.be301f33.svg";